import React from 'react';
import {
  CalendarCheck, MessageSquareQuote, CalendarDays, Tag, FileText, CreditCard,
  RotateCcwSquare, XSquare, Truck, Car, Radio, MessageCircle, BarChart2,
  ShieldCheck, ShieldOff, Settings, BadgeCheck, FileWarning, FileCheck,
  Ambulance, Users, UserCheck, Star, Ban, Ticket,
  AlertTriangle, UserX, ClipboardList,
} from 'lucide-react';

const CATEGORIES = [
  {
    label: 'Booking & Commerce',
    items: [
      { icon: CalendarCheck, label: 'Smart Booking Management' },
      { icon: MessageSquareQuote, label: 'Guest Quotes' },
      { icon: CalendarDays, label: 'Booking Calendar' },
      { icon: FileText, label: 'Rental Agreement' },
      { icon: Tag, label: 'Discount Codes' },
      { icon: CreditCard, label: 'Payment Methods' },
      { icon: RotateCcwSquare, label: 'Refund Process' },
      { icon: XSquare, label: 'Cancellation Policy' },
    ],
  },
  {
    label: 'Fleet & Operations',
    items: [
      { icon: Truck, label: 'Fleet Management' },
      { icon: Car, label: 'Vehicle Profile' },
      { icon: Radio, label: 'Telematics' },
      { icon: MessageCircle, label: 'Schedule Messages' },
      { icon: MessageCircle, label: 'In App messaging' },
      { icon: ClipboardList, label: 'Digital Claims Management' },
      { icon: BarChart2, label: 'Analytics & Reporting' },
      { icon: UserX, label: 'Report Guests' },
    ],
  },
  {
    label: 'Insurance & Protection',
    items: [
      { icon: ShieldCheck, label: 'Guest Protection Plans' },
      { icon: ShieldCheck, label: 'On-Rent Coverage' },
      { icon: ShieldOff, label: 'Off-Rent Coverage' },
      { icon: Settings, label: 'Coverage Settings' },
      { icon: BadgeCheck, label: 'Auto Insurance Validation' },
      { icon: FileWarning, label: 'Insurance Claims' },
      { icon: Ambulance, label: 'Roadside Assistance', badge: 'Add-On' },
      { icon: Users, label: 'Personal / Leisure Rental' },
    ],
  },
  {
    label: 'Trust & Safety',
    items: [
      { icon: UserCheck, label: 'ID & Selfie Check' },
      { icon: FileCheck, label: 'License Status Check' },
      { icon: AlertTriangle, label: 'Criminal Check' },
      { icon: Car, label: 'Motor Vehicle Report' },
      { icon: Ban, label: 'National BlockList' },
      { icon: Ticket, label: 'Tolls & Tickets', badge: 'Add-On' },
      { icon: AlertTriangle, label: 'Renter Violations' },
      { icon: Star, label: 'Review Management' },
    ],
  },
];

const WhatsIncludedSection = () => (
  <div className="vipo-included-sticky">
    <section className="vipo-included-inner">
      <div className="vipo-container vipo-container--wide">
        <div className="vipo-section__header">
          <p className="vipo-section__label">All included</p>
          <h2 className="vipo-section__heading">Embedded rental tools and workflows</h2>
          <p className="vipo-section__intro">
            The world's first rental back office, with AI powered automations, for operators like you.
          </p>
        </div>

        <div className="vipo-included__grid">
          {CATEGORIES.map(({ label, items }) => (
            <div key={label}>
              <p className="vipo-included__col-label">{label}</p>
              <ul className="vipo-included__list">
                {items.map(({ icon: Icon, label: itemLabel, badge }) => (
                  <li key={itemLabel} className="vipo-included__item">
                    <Icon className="vipo-included__icon" size={15} strokeWidth={1.5} />
                    <span>{itemLabel}</span>
                    {badge && (
                      <span className="vipo-included__badge">{badge}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default WhatsIncludedSection;
